<div class="row">
 
  <div class="col-12" style="height: 90vh !important; overflow: auto;">
    <form [formGroup]="AddAnswerChoiceform">
    <!-- <div class="row p-3">
      <div class="col-12 px-3">
        <div class="row d-flex">
          <div class="px-1">
           
            <button type="button"  class="btn btn-sm bg-light border">Add Text</button>
          </div>
         
        </div>
      </div>
    </div> -->
    <!-- <div class="row">
    <div class="col-12 text-right">
      <div class="row">
        <div class="col-11 px-3">
          <textarea maxlength="2000"
            class="form-control input-txt1" (ngModelChange)="Descriptioncount()" formControlName="Answer_Choice_Body_Text" id="txtdescription"></textarea>
          <label class="form-check-label maxlength" for="exampleCheck1">Characters {{Descriptionvaluelength}}/{{DescriptionMaxlength}}</label>
        </div>
      </div>
    </div>
    </div> -->
    <!-- <div class="row p-3">
      <div class="col-12">
        <div class="row d-flex">
          <div class="px-1">
           
            <button type="button" class="btn btn-sm bg-light border">Add Image</button>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-7 px-3">
            <textarea
              class="form-control input-txt1" id="txtdescription"></textarea>
           
          </div>
          <div class="col-4">
                <div class="row d-flex pt-2">
                  <div class="px-1">
                  
                    <button type="button" class="btn btn-sm bg-light border">Browse</button>
                  </div>
                 
              </div>
          </div>
        </div>
      </div>
      </div> -->
      <div class="row pt-2" *ngIf="alltheaboveviewflag">
        <div class="col-12">
          <div class="row">
         
            <div class="col-12">
              <div class="d-flex">
                <div class="px-1">
              <div class="form-check">
                <input type="checkbox" 
                  class="form-check-input" (click)="Alltheabove()" [checked]="Alltheaboveflag">
                <label class="form-check-label" for="exampleCheck1" >All of the Above</label>
              </div>
                </div>
                <div class="px-1">
              <div class="form-check">
                <input type="checkbox" 
                  class="form-check-input" (click)="Noneoftheabove()" [checked]="Noneoftheaboveflag" >
                <label class="form-check-label" for="exampleCheck1" >None of the Above</label>
              </div>
              </div>
            </div>
        
          </div>
        </div>
        
      </div>
      </div>
      <app-tinymce [RTEFlag]="RTEFlag" [ALLAboveNoneAboveChoiceflag]="ALLAboveNoneAboveChoiceflag" (GetLatexBodyContentchanges)="GetLatexBodyContentchanges($event)" (GetAnswerChoiceContent)="GetAnswerChoiceContent($event)" [QuestionBodyget]="QuestionBodyget"></app-tinymce>
      <!-- <app-quill-rte [RTEFlag]="RTEFlag" (GetLatexBodyContentchanges)="GetLatexBodyContentchanges($event)" (GetAnswerChoiceContent)="GetAnswerChoiceContent($event)" (GetLatexBodyContent)="GetLatexBodyContent($event)" [QuestionBodyget]="QuestionBodyget"></app-quill-rte> -->
    </form>
      <!-- <div class="row" *ngIf="latexeditlist.length>0"> 
        <div class="col-12 headersize">
           Latex Equation List
        </div>
        <div class="col-12">
          <div class="row">
            <div class="col-12" >
              <table class="table table-sm table-bordered">
                <thead>
                  <tr class="table-secondary table-bordered border-secondary">
                    <th class="col-md-1"></th>

                    <th class="col-md-6">Latex Formula</th>
                    <th class="col-md-5">Equation</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="table-secondary table-bordered border-secondary" *ngFor="let s of latexeditlist;let i=index">
                    <td>
                      <div class="d-flex pt-1">
                        
             
                       
                        <div class="px-3  tree-btn-1" >
                          <button type="button" class="tree-btn" (click)="copyInput(i)">
                              <i class="fa fa-copy" title="Copy"></i>
                          </button>
                        </div>
                        <div class="px-3  tree-btn-1">
                          <button type="button" class="tree-btn" (click)="Editlatexbutton(i)">
                              <i class="fa fa-edit" title="Edit"></i>
                          </button>
                        </div>
                      </div>
                    </td>
                  
                    <td>
                      <div><input type="text" [attr.disabled]="true" class="form-control form-control-sm" [(ngModel)]="s.latex" (ngModelChange)="Editlatex($event,i)"></div>
                    </td>
                    <td>
                      <div class="ql-editor py-1">
                        <div class="col-12">
                          <div  [innerHTML]="s.mathjax"></div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
      </div>
    </div>
        </div>
      </div> -->
      <form [formGroup]="AddAnswerChoiceform">
      <div class="row pt-3">
        <div class="col-8">
          <div class=" d-flex">
            <div class="px-1">
             
              <button type="button"  class="btn btn-sm bg-light border" [disabled]='this.AnswerChoiceList==0' (click)="AnswerRedirecttoPreview()">Preview</button>
            </div>
            
            <div class="px-1">
             
              <button type="button" [disabled]="(!AddAnswerChoiceform.valid)&&(!this.Alltheaboveflag&&!this.Noneoftheaboveflag)" (click)="SaveAnswerChoice()" class="btn btn-sm bl-btn">Save</button>
            </div>
            <div class="px-1">
             
              <button type="button"  class="btn btn-sm bg-light border" (click)="Cancel()">Cancel</button>
            </div>
            <!-- <div class="px-1">
            
              <button type="button" (click)="Cancel()" class="btn btn-sm bg-light border">Cancel</button>
            </div> -->
            <div class="px-1" *ngIf="this.AnswerChoiceList!=0">
             
              <button type="button"  [disabled]="addanswerchoiceflag" [hidden]="this.AnswerChoiceList==0" (click)="AddAnswerChoice()" class="btn btn-sm bg-light border">Add Anwser</button>
            </div>
            <div class="px-1" *ngIf="this.Answerflag=='R'">
             
              <button type="button" [disabled]="Rightansweravailable=='N'" [hidden]="this.Answerflag!='R'" (click)="AnswerChoiceNoteBody()" class="btn btn-sm bg-light border">Add Answer Note</button>
            </div>
            <div class="px-1" *ngIf="this.Answerflag=='R'">
             
              <button type="button" [disabled]="Rightansweravailable=='N'" [hidden]="this.Answerflag!='R'" (click)="AddSolutionHint()" class="btn btn-sm bg-light border">Add Solution Hint</button>
            </div>
            
           
            <div class="px-1">
             
              <button type="button"  class="btn btn-sm bg-light border" [disabled]='this.AnswerChoiceList==0' (click)="DeleteAnswerChoice('test')">Delete Answer</button>
            </div>
           
          </div>
        </div>
        <div class="col-4 px-3">
          <div class=" d-flex justify-content-end">
            <div class="px-1">
             
              <button type="button"  class="btn btn-sm bg-light border" [disabled]="Previousflag" (click)="PreviousflagButton()">Previous Answer</button>
            </div>
            <!-- <div class="px-1">
            
              <button type="button" (click)="Cancel()" class="btn btn-sm bg-light border">Cancel</button>
            </div> -->
            <div class="px-1">
             
              <button type="button" class="btn btn-sm bg-light border" [disabled]="Nextflag" (click)="NextButton()">Next Answer</button>
            </div>
          </div>
        </div>
      </div>
      </form>
</div>
<div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="alertpopupflag">
  <div class="modal-dialog modal-dialog-alert1 modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Save Changes</h6>
        <button type="button" class="close" 
          style="padding-right: 20px;font-size: 30px;outline: 0;" (click)="Alertpopup()">
          <span aria-hidden="true">&times;</span></button>
      </div>
     
      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Would you like to Save Changes ?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button type="button"  class="btn btn-sm bl-btn" (click)="Savecontent()" >Yes</button>
              </div>
              <div class="px-1">
                <button type="button"  class="btn btn-sm bg-light border" (click)="close()">No</button>
              </div>
              
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</div>
<!-- <div class="modal fade  show Model_popup1" *ngIf="editlatexbutton">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Edit">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Edit Latex Text</h6>
        <button type="button" class="close"
          (click)="closelatexpopup()" style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>
     
      <div class="modal-body px-3 py-0">
        <div class="row">
 
          <div class="col-12" style="height: 55vh !important; overflow: auto;">
            <div class="row">
              <div class="col-12">
                <div class="row">


                  <div class="row">
    
                    <div class="col-5 headersize">
                      Enter latex formula
                    </div>
                    <div class="col-7">
          
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <textarea  style="height: 40vh;" [(ngModel)]="getlatex"
                      class="form-control" ></textarea>
                    </div>
                  </div>
                  <div class="row">

                        <div class="col-12 px-2 pt-2">
                          <div class="d-flex">
                            <div class="px-1">
                             
                              <button type="button"  class="btn btn-sm bl-btn" (click)="Savelatex()">Accept</button>
                            </div>
                           
                            <div class="px-1">
                             
                              <button type="button" class="btn btn-sm bg-light border" (click)="LatexpopupCancel()">Cancel</button>
                            </div>
                           
                           
                          </div>
                        </div>
                     

                  </div>



              </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="latexalert">
          <div class="modal-dialog modal-dialog-alert1 modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header border Page-Header p-1 py-0">
                <h6 class="HeadContent" id="QuestionTemplatetitle">Save Changes</h6>
                <button type="button" class="close" 
                  style="padding-right: 20px;font-size: 30px;outline: 0;" (click)="latexAlertpopup()">
                  <span aria-hidden="true">&times;</span></button>
              </div>
             
              <div class="modal-body px-3 py-0">
                <div class="row py-2 mx-2 pt-3">
                  <div class="col-12">
                    <label>Would you like to Save Changes ?</label>
                  </div>
                </div>
                <div class="row p-1">
                  <div class="col-12">
                    <div class="d-flex justify-content-center">
                      <div class="px-1">
                        <button type="button"  class="btn btn-sm bl-btn" (click)="Savelatexcontent()" >Save</button>
                      </div>
                      <div class="px-1">
                        <button type="button"  class="btn btn-sm bg-light border" (click)="closelatex()">Cancel</button>
                      </div>
                      
                    </div>
                  </div>
                </div>
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->
<div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="deletealertpopup">
  <div class="modal-dialog modal-dialog-alert modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
        <button type="button" class="close" (click)="DeleteAnswerchoicepopup()"
          style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>
     
      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Do you want to delete the Answer ?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button type="button"  class="btn btn-sm bl-btn" (click)="replacedeletebutton()">Yes</button>
              </div>
              <div class="px-1">
                <button type="button"  class="btn btn-sm bg-light border" (click)="CloseDeleteAlertpopup()">No</button>
              </div>
              
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</div>
<div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="rightansweralertflag">
  <div class="modal-dialog modal-dialog-alert modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
        <button type="button" class="close" (click)="rightAnsweralert()"
          style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>
     
      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>Are you adding a right Answer?</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button type="button"  class="btn btn-sm bl-btn" (click)="saverightanswer()">Yes</button>
              </div>
              <div class="px-1">
                <button type="button"  class="btn btn-sm bg-light border" (click)="savewronganswer()">No</button>
              </div>
              
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</div>
<div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="Wrongansweralertflag">
  <div class="modal-dialog modal-dialog-alert modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Alert</h6>
        <button type="button" class="close" (click)="Wrongansweralert()"
          style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>
     
      <div class="modal-body px-3 py-0">
        <div class="row py-2 mx-2 pt-3">
          <div class="col-12">
            <label>You have already added 7 wrong answers, please enter the right answer now.</label>
          </div>
        </div>
        <div class="row p-1">
          <div class="col-12">
            <div class="d-flex justify-content-center">
              <div class="px-1">
                <button type="button"  class="btn btn-sm bl-btn" (click)="saverightanswerinwrong()">Yes</button>
              </div>
              <div class="px-1">
                <button type="button"  class="btn btn-sm bg-light border" (click)="Wrongansweralert()">No</button>
              </div>
              
            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</div>


